module.exports = __webpack_public_path__ + "static/img/yy6.44043c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yy6.png
// module id = 9fGR
// module chunks = 1